module.exports = __webpack_public_path__ + "47ed0f0c93061e87750eca5b2d17fd29.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/app-store-logo.png
// module id = 2855
// module chunks = 0